import type {
  GetRetailUnitResponse,
  GetRetailUnitParams,
  GetAllRetailUnitsResponse,
  GetAllRetailUnitsParams,
} from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const retailUnitApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getRetailUnit: build.query<GetRetailUnitResponse, GetRetailUnitParams>({
      query: ({ retailUnit }) => `/${retailUnit.toLowerCase()}`,
      // Custom cache key serialization to make it not care about upper/lower case
      serializeQueryArgs: ({ queryArgs: { retailUnit } }) => {
        // It will be undefined for skipped queries (bug in rtk query?)
        return retailUnit?.toLowerCase();
      },
    }),
    getAllRetailUnits: build.query<GetAllRetailUnitsResponse, GetAllRetailUnitsParams>({
      query: () => `/retail-unit/all`,
    }),
  }),
});

export const { useGetRetailUnitQuery, useGetAllRetailUnitsQuery } = retailUnitApis;
